import App from '@features/home/App';
import { PageNotFound } from '@features/common';
import homeRoute from '@features/home/route';
import commonRoute from '@features/common/route';
import messageRoute from '@features/message/route';
import articlesRoute from '@features/articles/route';

import { IRoute } from '@src/types';
import searchRoute from '@features/search/route';
import personalRoute from '@features/personal/route';
import articleRoute from '@features/article/route';
import askRoute from '@features/ask/route';
import tagRoute from '@features/tag/route';
import circleRoute from '@features/circle/route';
import teamRoute from '@features/team/route';
import voteRoute from '@features/vote/route';
import adminRoute from '@features/admin/route';
import activeRoute from '@features/active/route';
import mallRoute from '@features/mall/route';
import thematicRoute from '@features/thematic/route';

export const childRoutes = [
  homeRoute,
  commonRoute,
  messageRoute,
  searchRoute,
  articlesRoute,
  personalRoute,
  articleRoute,
  askRoute,
  tagRoute,
  circleRoute,
  teamRoute,
  voteRoute,
  adminRoute,
  activeRoute,
  mallRoute,
  thematicRoute
];

const routes: IRoute[] = [
  // default layout
  {
    path: '/',
    // @ts-ignore
    component: App,
    auth: false,
    childRoutes: [
      // @ts-ignore
      ...childRoutes,
      { path: '*', name: 'Page not found', auth: false, component: PageNotFound }
    ].filter(
      (r: IRoute) => r.component || r.redirect || (r.childRoutes && r.childRoutes.length > 0)
    )
  }
  // other layout
];

function handleIndexRoute(route: IRoute) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute: IRoute | undefined = route.childRoutes.find(child => !!child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true;
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;
